import React, { useState } from "react";

import InsuredPersonValidationForm from "../insured-person-validation-form/insured-person-validation-form.component";
import RegisterForm from "../register-form/register-form.component";
import SuccessResult from "../success-result/success-result.component";

import "./register.styles.css";

export const INITIAL_STATE_INSURED_PERSON = {
    name: null,
    isUser: false,
};
const INITIAL_STATE_RESULT = {
    show: false  ,
    message: "",
};

const Title = () => (
    <div className="register-header">
        <h2 className="register-title">Registro de Asegurados</h2>
    </div>
);

const Register = () => {
    const [isInsuredPerson, setIsInsuredPerson] = useState(false);
    const [insuredPerson, setInsuredPerson] = useState(
        INITIAL_STATE_INSURED_PERSON
    );
    const [result, setResult] = useState(INITIAL_STATE_RESULT);

    const resetRegister = () => {
        setResult(INITIAL_STATE_RESULT);
        setIsInsuredPerson(false);
    };

    const onOkRegister = (message) =>
        setResult({
            show: true,
            message,
        });

    return result.show ? (
        <SuccessResult title={result.message} onPressExtraBtn={resetRegister} />
    ) : (
        <>
            <Title />
            {!isInsuredPerson ? (
                <InsuredPersonValidationForm
                    setIsInsuredPerson={setIsInsuredPerson}
                    setInsuredPerson={setInsuredPerson}
                />
            ) : (
                <RegisterForm
                    insuredPerson={insuredPerson}
                    onOkRegister={onOkRegister}
                />
            )}
        </>
    );
};

export default Register;
